














































import moment from 'moment';
import Vue from 'vue';

import InputCountry from '@/vue/components/input/Country.vue';

export default Vue.extend({
  components: {
    'input-country': InputCountry,
  },

  props: {
    visible: Boolean as () => boolean,
  },

  data() {
    return {
      form: this.$form.createForm(this),
      today: moment(0, 'HH'),
    };
  },

  methods: {
    disabledDate(date: moment.Moment): boolean {
      return date <= this.today;
    },

    handleSubmit() {
      this.form.validateFields((errors: Error[], values: any) => {
        if (errors === null) {
          this.$emit('submit', {
            country: values.country,
            date: values.date.format('YYYY-MM-DD'),
          });

          this.form.resetFields();
        }
      });
    },
  },
});
